import React, { useState, useEffect } from 'react';
import { getConfig } from '../services/api';

const ConfigViewer = ({ configName }) => {
  const [configData, setConfigData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        setLoading(true);
        const data = await getConfig(configName);
        setConfigData(data);
        setLoading(false);
      } catch (error) {
        setError(`Error loading ${configName} configuration`);
        setLoading(false);
      }
    };
    if (configName) {
      fetchConfig();
    }
  }, [configName]);

  if (loading) {
    return <div>Loading configuration...</div>;
  }
  if (error) {
    return <div className="error-message">{error}</div>;
  }
  if (!configData) {
    return <div>No configuration data available</div>;
  }

  // Determine configuration name for display
  let configDisplayName = configName;
  if (configName === 'CREWS') {
    configDisplayName = 'Climate Risk and Early Warning Systems Configuration';
  } else if (configName === 'AF') {
    configDisplayName = 'Adaptation Fund Configuration';
  } else if (configName === 'GCF') {
    configDisplayName = 'Green Climate Fund Configuration';
  } else if (configName === 'GEF') {
    configDisplayName = 'Global Environment Facility Configuration';
  } else if (configName === 'WB') {
    configDisplayName = 'World Bank Configuration';
  } else if (configName === 'SOFF') {
    configDisplayName = 'Systematic Observations Financing Facility Configuration';
  } else if (configName === 'IADB') {
    configDisplayName = 'Inter American Development Bank Configuration';
  } else if (configName === 'ADB') {
    configDisplayName = 'Asian Development Bank Configuration';
  } else if (configName === 'AFDB') {
    configDisplayName = 'African Development Bank Configuration';
  }

  
  return (
    <div className="config-details">
      <h2>{configDisplayName}</h2>
      
      <div className="config-section">
        <h3>Role and Goal</h3>
        <div className="config-content">
          {configData.role_and_goal}
        </div>
      </div>
      
      <div className="config-section">
        <h3>Additional Instructions</h3>
        <div className="config-content">
          {configData.extra_input}
        </div>
      </div>
    </div>
  );
};

export default ConfigViewer;